import store from '@/state/store'
// import { component } from 'vue/types/umd.js'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: 'home' })
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: 'home' })
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, routeFrom, next) {
                await store.dispatch('auth/logout')

                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/reset-password',
        name: 'Reset password',
        component: () => import('../views/pages/account/create-password-forgot'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                next()
            },
        },
    },
    {
        path: '/first-time-password',
        name: 'Create-password',
        component: () => import('../views/pages/account/create-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                next()
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domain/domainListing')
    },
    {
        path: '/domain',
        name: 'Domain-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domain/domainListing')
    },
    {
        path: '/domain/create',
        name: 'Domain-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domain/domainCreate')
    },
    {
        path: '/domain/update',
        name: 'Domain-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domain/domainUpdate')
    },
    {
        path: '/domain/results',
        name: 'Domain-results',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domain/domainResults')
    },
    {
        path: '/domain-group',
        name: 'Domain-group-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domainGroup/domainGroupListing')
    },
    {
        path: '/domain-group/create',
        name: 'Domain-group-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domainGroup/domainGroupCreate')
    },
    {
        path: '/domain-group/update',
        name: 'Domain-group-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/domainGroup/domainGroupUpdate')
    },
    {
        path: '/password-reset',
        name: 'Password-reset-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/passwordReset/passwordResetListing')
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/profile')
    },
    {
        path: '/users',
        name: 'Users-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/main')
    },
    {
        path: '/user',
        name: 'User-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/userListing')
    },
        {
        path: '/user/update',
        name: 'User-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/userUpdate')
    },
    {
        path: '/user/create',
        name: 'User-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/userCreate')
    },
    {
        path: '/other',
        name: 'Other-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/other/main')
    },
    {
        path: '/role',
        name: 'Role-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/role/roleListing')
    },
    {
        path: '/role/update',
        name: 'Role-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/role/roleUpdate')
    },
    {
        path: '/role/create',
        name: 'Role-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/role/roleCreate')
    },
                {
        path: '/company',
        name: 'Company',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/company/main.vue')
    },
    {
        path: '/company/list',
        name: 'Company-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/company/companyListing.vue')
    },
                        {
        path: '/configuration',
        name: 'Configuration-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/configuration/configurationListing')
    },
                                    {
        path: '/supplier',
        name: 'Supplier-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/supplier/supplierListing.vue')
    },
    {
        path: '/supplier/create',
        name: 'Supplier-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/supplier/supplierCreate.vue')
    },
    {
        path: '/supplier/update',
        name: 'Supplier-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/supplier/supplierUpdate.vue')
    },

]
